import { render, staticRenderFns } from "./FabItem.vue?vue&type=template&id=57db5fde&scoped=true&"
import script from "./FabItem.vue?vue&type=script&lang=js&"
export * from "./FabItem.vue?vue&type=script&lang=js&"
import style0 from "./FabItem.vue?vue&type=style&index=0&id=57db5fde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db5fde",
  null
  
)

export default component.exports